var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19776 12.0574C5.08693 12.0574 4.97609 12.0166 4.88859 11.9291C4.71943 11.7599 4.71943 11.4799 4.88859 11.3107L8.69193 7.50739C8.97193 7.22739 8.97193 6.77239 8.69193 6.49239L4.88859 2.68906C4.71943 2.51989 4.71943 2.23989 4.88859 2.07072C5.05776 1.90156 5.33776 1.90156 5.50693 2.07072L9.31026 5.87406C9.60776 6.17156 9.77693 6.57406 9.77693 6.99989C9.77693 7.42572 9.61359 7.82822 9.31026 8.12572L5.50693 11.9291C5.41943 12.0107 5.30859 12.0574 5.19776 12.0574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightWhite);
export default __webpack_public_path__ + "static/media/chevron-right-white.249901774dcdc3a60b92be2b0589a411.svg";
export { ForwardRef as ReactComponent };